import React, { useState, useEffect } from "react";
import styles from "./Products.module.css";
import product1 from "../../../assets/landing/products/product 1 img.png";
import product2 from "../../../assets/landing/products/product 2 img.png";
import product3 from "../../../assets/landing/products/product 3 img.png";

const Products = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const features = [
    {
      id: 0,
      title: "Unified Meeting Assistant",
      highlights: [
        "Automated call recording",
        "Real-time transcription",
        "Indian accent tuned AI with multiple language support",
        "AI generated summaries & highlights",
        "One-click follow-up emails"
      ],
      image: product1
    },
    {
      id: 1,
      title: "Conversation Intelligence",
      subtitle: "AI analyzes every interaction to surface:",
      highlights: [
        "Speaker sentiment signals",
        "Competitor mentions",
        "Likelihood of closing a deal",
        "Sales rep performance metrics",
        "Deal risks & opportunities"
      ],
      image: product2
    },
    {
      id: 2,
      title: "Built-in CRM",
      highlights: [
        "Utilize our built-in CRM designed for Indian SMBs\n or integrate with leading CRMs",
        "Automatically syncs notes, insights,and follow-ups",
        "Inspect deal health and improve forecasting accuracy"
      ],
      image: product3
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setActiveTab((prev) => (prev + 1) % features.length);
        setIsAnimating(false);
      }, 300);
    }, 8000);

    return () => clearInterval(interval);
  }, [features.length]);

  const handleTabClick = (index) => {
    if (index !== activeTab) {
      setIsAnimating(true);
      setTimeout(() => {
        setActiveTab(index);
        setIsAnimating(false);
      }, 300);
    }
  };

  return (
    <section id="product" className={styles.products}>
      <div className={styles.container}>
        <h2 className={styles.mainHeading}>
          Meet <span className={styles.brandName}>Galile</span> — Your{" "}
          <span className={styles.highlight}>AI Revenue Brain</span>
        </h2>

        <div className={styles.tabsContainer}>
          <div className={styles.tabs}>
            {features.map((feature, index) => (
              <div key={feature.id} className={styles.tabWrapper}>
                <button
                  className={`${styles.tab} ${activeTab === index ? styles.activeTab : ""}`}
                  onClick={() => handleTabClick(index)}
                >
                  <div className={styles.tabTitle}>
                    {feature.title}
                  </div>
                </button>
                {activeTab === index && (
                  <div className={styles.tabProgress}>
                    <div className={styles.tabProgressFill} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.contentContainer}>
          <div className={styles.textContent}>
            <h3 className={styles.featureTitle}>
              {features[activeTab].title}
            </h3>
            {features[activeTab].subtitle && (
              <p className={styles.featureSubtitle}>
                {features[activeTab].subtitle}
              </p>
            )}
            <ul className={styles.featureList}>
              {features[activeTab].highlights.map((item, index) => (
                <li key={index} className={styles.featureItem}>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.imageContent}>
            <div
              className={`${styles.screenshotPlaceholder} ${isAnimating ? styles.fadeOut : styles.fadeIn
                }`}
            >
              <img 
                src={features[activeTab].image} 
                alt={features[activeTab].title}
                className={styles.productImage}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;